import { format, formatDistance, formatRelative, subDays } from 'date-fns'

export function dateStringToDatePretty(dateString, formatString = 'MMM do, yyyy') {
    let date = new Date(dateString)
    return format(date, formatString)
}

export function dateMonthYearPretty(month, fullYear) {
    let date = new Date()
    date.setMonth(month - 1)
    date.setFullYear(fullYear)

    if(date < new Date(1920, 1, 1)) {
        return null
    }

    return dateStringToDatePretty(date, 'MMM yyyy')
}

export function dateMonthYearSpanPretty(startMonth, startYear, endMonth, endYear) {
    let startString = dateMonthYearPretty(startMonth, startYear)
    let endString = (endMonth && endYear) ? dateMonthYearPretty(endMonth, endYear) : 'current'
    return [startString, endString].filter((str) => !!str).join(' to ')
}

export function dateTimeRelative(dateInstance) {
    return formatRelative(dateInstance, new Date())
}
